// extracted by mini-css-extract-plugin
module.exports = {"tsBlue":"#1a6baf","tsDarkBlue":"#13426e","tsOrange":"#ff8f00","tsDarkOrange":"#f75b02","tsGreen":"#7fc243","tsRed":"#e26362","tsBlack":"#222","tsGrey":"#d6d6d6","tsWhite":"#fff"};